module.exports = __webpack_public_path__ + "img/logo-white.192d8dce.png";